//modify start > loan tabs

function changeLoanTab(tab) {
    console.log("change-loan-tab frm custom2.js");
    const loanTabs = document.querySelectorAll('.loan-input');
    const loanContents = document.querySelectorAll('.loan-input-content');
    console.log(tab)
    loanTabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    const target = tab.getAttribute('data-bs-target');
    loanContents.forEach(content => {
        content.classList.remove('active');
        if (content.id === target) {
            content.classList.add('active');
        }
    });
}

function InitStudentTabs(){
    const studentTabs = document.querySelectorAll('.student-tab');
    const studentContents = document.querySelectorAll('.st-content');
    
    studentTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            studentTabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            
            const target = tab.getAttribute('data-bs-target');
            studentContents.forEach(content => {
                content.classList.remove('active');
                if (content.id === target) {
                    content.classList.add('active');
                }
            });
        });
    });    
}

function canEnableRollback1(){
    const rollbackLink = document.getElementById('rollback_idd');
    try{
        const rollbackText = rollbackLink.innerText
        return rollbackText;    
    }catch(e){
        return false;
    }

}

function openRollback1(){
    document.getElementById('rollback_idd').click();

}